export default __webpack_public_path__ + "static/media/HomeCover.282bd468.jpg";